// Variant UI only. Shopify's native form owns add-to-cart and checkout.
(() => {
  document.querySelectorAll('[data-program-product]').forEach(root => {
    const select = root.querySelector('[data-program-variant]');
    if (!select) return;
    const update = () => {
      const option = select.selectedOptions[0];
      const button = root.querySelector('[data-product-submit]');
      if (!option || !button) return;
      const available = option.dataset.available === 'true';
      root.querySelector('[data-product-price]').textContent = option.dataset.price;
      button.disabled = !available;
      button.querySelector('[data-submit-label]').textContent = available ? button.dataset.availableLabel : button.dataset.unavailableLabel;
      const url = new URL(location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState(null, '', url);
    };
    select.addEventListener('change', update);
    update();
  });
})();
